module.exports = __webpack_public_path__ + "media/images/course/6-7baf0225c8908d7b1185b2ed6ac5dc39.png";